import H from 'constants/httpMethod.const';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

const L = logger('bePosTipsRead'); // eslint-disable-line no-unused-vars

const fromDtoToTips = (dto) => ({
  sendTipsToMainStripeAccount: dto?.send_tips_to_main_stripe_account,
  takeTipViaPos: dto?.take_tip_via_pos,
});

const fromTipsToDto = (item) => ({
  send_tips_to_main_stripe_account: item?.sendTipsToMainStripeAccount,
  take_tip_via_pos: item?.takeTipViaPos,
});

export const bePosTipsRead = actionEndpointBe('bePosTipsRead', H.get, 'settings/postips/:salonId/', (options) => ({
  ...options,
  inert: true,
  fromDto: fromDtoToTips,
}));

export const bePosTipsWrite = actionEndpointBe(
  'bePosTipsWrite',
  H.put,
  'settings/postips/:salonId/',
  (options, extra) => ({
    ...options,
    inert: true,
    fromDto: fromDtoToTips,
    toDto: fromTipsToDto,
    data: extra?.data,
  }),
);
